import { Text, TextProps } from '@chakra-ui/react'
import React from 'react'

export default function DotSeparator(props: TextProps) {
    return (
        <Text mx={2} {...props}>
            •
        </Text>
    )
}
